import { useState, useEffect } from 'preact/hooks';

export default function useSessionStorage(key, initialState) {
	const [value, setValue] = useState(getStorage(key) || initialState);

	useEffect(() => {
		setStorage(key, value);
	}, [key, value]);

	return [value, setValue];
}

const storageKey = 'mopDeploy';

function getStorage(key) {
	try {
		const obj = JSON.parse(sessionStorage.getItem(storageKey))?.[key] ?? {};
		const isExpired = new Date().getTime() > Number(obj.time);

		if (isExpired) {
			return undefined;
		}

		return obj.value;
	} catch (e) {
		return undefined;
	}
}

function setStorage(key, value) {
	try {
		const newState = JSON.parse(sessionStorage.getItem(storageKey)) ?? {};
		const updateState = {
			time: new Date().getTime() + 60000 * 10, //expires in 10 minutes
			value
		};

		if (newState[key]) {
			Object.assign(newState[key], updateState);
		} else {
			newState[key] = updateState;
		}
		sessionStorage.setItem(storageKey, JSON.stringify(newState));
	} catch (e) {}
}
